import React from 'react'
import { useLocation } from 'react-router-dom'
import Header from '@/components/common/header'
import Footer from '@/components/common/footer'
import { routes } from '@/routes/routes'
import styled from 'styled-components'

interface LayoutProps {
  children: React.ReactNode
}

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  align-items: center;
`
const LayoutMain = styled.div<{ isFullWidth: boolean }>`
  width: ${(props) => (props.isFullWidth ? '90%' : '70%')};
  display: flex;
  flex-direction: column;
  flex: 1;
`

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation()
  const currentRoute = routes.find(
    (route) => route.path === location.pathname,
  ) || {
    hideHeader: false,
    hideFooter: false,
    isFullWidth: false,
  }

  const hideHeader = currentRoute?.hideHeader ?? false
  const hideFooter = currentRoute?.hideFooter ?? false
  const isFullWidth = currentRoute?.isFullWidth ?? false
  return (
    <LayoutContainer>
      {!hideHeader && <Header />}
      <LayoutMain isFullWidth={isFullWidth}>
        <main style={{ flex: 1 }}>{children}</main>
      </LayoutMain>
      {!hideFooter && <Footer />}
    </LayoutContainer>
  )
}

export default Layout
